module.exports = __webpack_public_path__ + "static/media/length.b96d5c62.svg";